<mat-spinner *ngIf="!rowsData"></mat-spinner>
<table class="table table-striped" *ngIf="rowsData && columnsData">
  <thead>
    <tr>
      <th scope="col" *ngFor="let col of columnsData">{{col.header}}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let row of rows" (ngModelChange)="refresh()">
      <td scope="row" *ngFor="let col of columnsData">
        <span>{{ row[col.field] }}</span>
        <!-- <span *ngIf="col.field !== 'edit'">{{ row[col.field] }}</span>
        <span *ngIf="col.field === 'edit'">
          <a (click)="edit(row[columnsData[0].field])">
            <img src="../../../../assets/edit.png" style="width: 20px;">
          </a>
        </span> -->
      </td>
    </tr>
  </tbody>
</table>

<div class="d-flex justify-content-center p-2">
  <ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [pageSize]="pageSize" (pageChange)="refresh()">
  </ngb-pagination>
</div>
<select class="custom-select" style="width: auto; float: right; margin-right: 30px;" [(ngModel)]="pageSize"
  (ngModelChange)="refresh()">
  <option [ngValue]="10">10 items per page</option>
  <option [ngValue]="15">15 items per page</option>
  <option [ngValue]="20">20 items per page</option>
</select>
